import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SCREEN_NAME } from '../types/common/CommonType';

// 画面遷移順管理
const slice = createSlice({
    name: 'ScreenTransition',
    initialState: [SCREEN_NAME.SEARCH_TOP] as Array<string>,
    reducers: {
        // 全置換
        addRow: (state, action: PayloadAction<string>) => {
            state.unshift(action.payload);
        },
        // 初期化
        reset: () => {
            return [SCREEN_NAME.SEARCH_TOP];
        },
    },
});

export const { actions, reducer } = slice;
export const { addRow, reset } = actions;
